import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCKcuQUntkDtLwrQp9BvktSW5dH07k6uxg",
  authDomain: "gym-member-ae586.firebaseapp.com",
  projectId: "gym-member-ae586",
  storageBucket: "gym-member-ae586.appspot.com",
  messagingSenderId: "77903581370",
  appId: "1:77903581370:web:bd752fe2b4a92c515b3283"
};
// const firebaseConfig = {
//   apiKey: "AIzaSyDOCIlgBcdw8f9r_HXxdv_Kk-P3ierUofM",
//   authDomain: "test-ef3b2.firebaseapp.com",
//   projectId: "test-ef3b2",
//   storageBucket: "test-ef3b2.appspot.com",
//   messagingSenderId: "1046547102916",
//   appId: "1:1046547102916:web:917854e653ec8ba34f5d91",
//   measurementId: "G-MN6BT82L85",
// };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export var googleAuthProvider = new firebase.auth.GoogleAuthProvider();
export const projectStorage = firebase.storage();
